// src/pages/ManualsPage.js
import React from 'react';
import {
  Box, Grid, Card, CardContent, Typography, Chip,
  Button
} from '@mui/material';
import {
  MenuBook, Help, Security,
  LocalLaundryService, Science, Business
} from '@mui/icons-material';
import { useI18n } from '../i18n/i18n';

const ManualsPage = () => {
  const { t } = useI18n();

  const manuals = [
    {
      category: 'program_guides',
      items: [
        { key: 'manuals.getting_started', icon: <Help /> },
        { key: 'manuals.user_manual', icon: <MenuBook /> },
        { key: 'manuals.troubleshooting', icon: <Help /> },
        { key: 'manuals.faq', icon: <Help /> }
      ]
    },
    {
      category: 'product_guides', 
      items: [
        { key: 'manuals.towel_guide', icon: <LocalLaundryService /> },
        { key: 'manuals.sheet_guide', icon: <LocalLaundryService /> },
        { key: 'manuals.pillowcase_guide', icon: <LocalLaundryService /> },
        { key: 'manuals.napkin_guide', icon: <LocalLaundryService /> }
      ]
    },
    {
      category: 'safety_guides',
      items: [
        { key: 'manuals.chemical_usage', icon: <Science /> },
        { key: 'manuals.machine_operation', icon: <LocalLaundryService /> },
        { key: 'manuals.emergency_procedures', icon: <Security /> },
        { key: 'manuals.safety_equipment', icon: <Security /> }
      ]
    }
  ];

  return (
    <Box sx={{ p: 3, maxWidth: 1400, mx: 'auto' }}>
      <Typography variant="h3" component="h1" sx={{ fontWeight: 700, mb: 2 }}>
        {t('manuals.title')}
      </Typography>

      <Grid container spacing={3}>
        {manuals.map((category) => (
          <Grid item xs={12} sm={6} lg={4} key={category.category}>
            <Card sx={{ height: '100%' }}>
              <CardContent sx={{ p: 3 }}>
                <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                  {t(`manuals.${category.category}`)}
                </Typography>
                
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
                  {category.items.map((item, index) => (
                    <Button
                      key={index}
                      variant="outlined"
                      startIcon={item.icon}
                      fullWidth
                      sx={{ 
                        justifyContent: 'flex-start',
                        py: 1.5,
                        textTransform: 'none'
                      }}
                    >
                      <Typography variant="body1" sx={{ textAlign: 'left' }}>
                        {t(item.key)}
                      </Typography>
                    </Button>
                  ))}
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ManualsPage;